import React from "react";
function ProductSelectedName(props) {
  return <p>{props.name}</p>;
}

export default ProductSelectedName;
